module.exports = __webpack_public_path__ + "img/light-arrow-right.62f34b25.svg";